import { render, staticRenderFns } from "./Railway.vue?vue&type=template&id=67131a56&"
import script from "./Railway.vue?vue&type=script&lang=js&"
export * from "./Railway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports